import { Skeleton } from '@skin-seoul/design-system';

export const LoyaltyPointsBannerSkeleton = () => {
  return (
    <div className="relative w-full rounded-[8px] bg-neutral-100 overflow-hidden px-4 py-6 tablet:py-4">
      <div className="relative z-[1] flex items-center justify-between h-full">
        {/* Title Skeleton */}
        <div className="flex flex-col gap-1">
          <Skeleton className="w-[80px] h-[20px]" />
          <Skeleton className="w-[100px] h-[20px]" />
        </div>

        {/* Points Skeleton */}
        <div className="flex flex-col gap-1 items-end">
          <Skeleton className="w-[70px] h-[14px]" />
          <Skeleton className="w-[80px] h-[24px]" />
        </div>
      </div>
    </div>
  );
};
